<template>
	<div class="relative !px-4 !py-16 flex flex-col gap-4 items-center !container mx-auto !max-w-seint">
		<button
			type="button"
			aria-label="Go Back"
			@click="handleBackStep"
			class="inline-flex items-center absolute left-4 top-5 gap-2 text-[11px]/[14px] uppercase font-medium"
		>
			<svg-vue icon="back-arrow" />
			<span>Back</span>
		</button>
		<h1 class="!m-0 !p-0 font-butler-light text-3xl/[38px] font-light text-center">
			What type of coverage do you like?
		</h1>
		<ul class="flex flex-col gap-3 w-full max-w-[400px] mx-auto !m-0 !p-0">
			<li>
				<button
					type="button"
					aria-label=""
					@click="() => handleNextStep('Light/Medium', 1)"
					:class="[
						'flex flex-col items-center justify-center',
						'w-full !p-3',
						'seint-border hover:ring-2 hover:ring-light-gray-900 hover:dark:ring-white',
						coverageName === 'Light/Medium' ? 'ring-2 ring-black' : 'border-brand-solid',
					]"
				>
					<span class="text-sm">Light / Medium</span>
					<span class="text-xs/[18px] max-w-80"> Filter blemishes and targeted areas plus add natural dimension. </span>
				</button>
			</li>
			<li>
				<button
					type="button"
					aria-label=""
					@click="() => handleNextStep('Medium/Full', 2)"
					:class="[
						'flex flex-col items-center justify-center',
						'w-full !p-3',
						'seint-border hover:ring-2 hover:ring-light-gray-900 hover:dark:ring-white',
						coverageName === 'Medium/Full' ? 'ring-2 ring-black' : 'border-brand-solid',
					]"
				>
					<span class="text-sm">Medium / Full</span>
					<span class="text-xs/[18px] max-w-80">
						A buildable finish that evens out skin tone and conceals imperfections while maintaining a natural look.
					</span>
				</button>
			</li>
		</ul>
	</div>
</template>
<script setup>
import { onMounted } from 'vue'

const props = defineProps({
	coverageName: {
		type: String,
		default: null,
	},
	setCoverageName: {
		type: Function,
		required: true,
	},
	setCoverageId: {
		type: Function,
		required: true,
	},
	setStep: {
		type: Function,
		required: true,
	},
})

onMounted(() => {
	window.scrollTo(0, 0)
})

const handleBackStep = () => props.setStep(2)
const handleNextStep = (selectionName, selectionId) => {
	props.setCoverageName(selectionName)
	props.setCoverageId(selectionId)
	props.setStep(4)
}
</script>
